import { useId } from "react";
import { CBQChoice } from "../../../../api/Quiz/InitCBQQuestion";
import ChoicesEditor from "./ChoicesEditor";
import { QuestionTypeEditorProps } from "./types";

// mcq: optionsJson { choices:[{key,text}] }, correctAnswerJson { answer:"A" }
const McqEditor = ({
  optionsJson,
  correctAnswerJson,
  onChange,
}: QuestionTypeEditorProps) => {
  // Radios sharing a name form one group document-wide, so a page-constant name
  // would let only the last-rendered question show its correct answer. One
  // group per editor instance keeps each question independent.
  const groupName = useId();
  const choices = (optionsJson.choices as CBQChoice[]) ?? [];
  const answer = (correctAnswerJson.answer as string) ?? "";

  const setChoices = (next: CBQChoice[]) => {
    const stillValid = next.some((c) => c.key === answer);
    onChange({
      optionsJson: { choices: next },
      correctAnswerJson: stillValid ? { answer } : {},
    });
  };
  const setAnswer = (key: string) =>
    onChange({ optionsJson: { choices }, correctAnswerJson: { answer: key } });

  return (
    <ChoicesEditor
      choices={choices}
      onChange={setChoices}
      renderCorrectControl={(key) => (
        <input
          type="radio"
          name={groupName}
          checked={answer === key}
          onChange={() => setAnswer(key)}
          title="Mark correct"
          className="h-4 w-4 accent-[#4379EE]"
        />
      )}
    />
  );
};

export default McqEditor;
